import { useUserPermissions } from '../PermissionAPI';
import { PermissionDTO } from '../PermissionDTO';
import { get } from 'es-toolkit/compat';
import { ReactElement } from 'react';
import { Lock } from '@material-ui/icons';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';

export interface PermissionIconProps<T extends keyof PermissionDTO> {
  children?: ReactElement;
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
  htmlColor?: string;
  fontSize?: 'small' | 'default' | 'inherit' | 'large' | 'medium';
}

export function PermissionIcon<T extends keyof PermissionDTO>({
  children,
  name,
  permission,
  htmlColor,
  fontSize,
}: PermissionIconProps<T>) {
  const { data: userPermission } = useUserPermissions();

  const hasPermission = get(userPermission, [name, permission]);
  const hasNotAccess = !hasPermission && !MobileAppBridge.isInjected();

  if (hasNotAccess) {
    return <Lock htmlColor={htmlColor} fontSize={fontSize} />;
  }

  return <div>{children}</div>;
}
